import { render, staticRenderFns } from "./OnboardingTopBar.vue?vue&type=template&id=563a48a8&scoped=true&"
import script from "./OnboardingTopBar.vue?vue&type=script&lang=js&"
export * from "./OnboardingTopBar.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTopBar.vue?vue&type=style&index=0&id=563a48a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a48a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAppBar,VImg,VSpacer})
